import TypographyElement from '@/views/elements/typography/TypographyElement';
import { Stack } from '@mui/system';

type StateMenuItem = {
  value: any,
  label: string
}

type StateMenuProps = {
  menu: StateMenuItem[],
  onStateChange: (state: any) => void,
  currentState: any
}

export default function StateMenu({ currentState, onStateChange, menu }: StateMenuProps) {
  return (
    <Stack direction='row' spacing='15px'>
      {
        menu.map((item: StateMenuItem) => <TypographyElement 
        onClick={() => onStateChange(item.value)}
        FontWeightElement={600}
        FontSizeElement='12px'
        ColorElement={currentState === item.value ? 'brand' : 'secondary'}
        sx={{
          width: 'fit-content',
          margin: 0,
          cursor: 'pointer',
          marginRight: '10px',
        }} >{item.label}</TypographyElement>)
      }
    </Stack>
  );
}